
import { Box, Card, CardContent, Divider, Typography, } from "@mui/material";
import RenderQuestion from "./RenderQuestion";
import { useTranslation } from "react-i18next";

const QuestionnaireFormSection = ({
  section,
  sectionIndex,
  formData,
  setFormData,
  errors,
  handleChange,
  handleFiles,
}) => {

  const { t } = useTranslation()

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 700,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Card
        sx={{
          borderRadius: 2,
          mb: 3,
          borderTop: (theme) => `8px solid ${theme.palette.secondary.main}`,
          boxShadow: 2,
        }}
      >
        <CardContent>
          <Typography variant="h5" sx={{ fontWeight: 500, mb: 1 }}>
            {section?.title || t('questionnaire.form.sectionTitle')}
          </Typography>
          {section?.description && (
            <Typography sx={{ mt: 1, color: "text.secondary" }}>
              {section?.description}
            </Typography>
          )}
          <Divider sx={{ my: 1 }} />
        </CardContent>
      </Card>

      {section?.questions?.map((q, i) => (
        <RenderQuestion
          q={q}
          key={q.id}
          sectionIndex={sectionIndex}
          handleChange={handleChange}
         error={errors.get(`${sectionIndex}-${q.id}`) || false}
          formData={formData}
          setFormData={setFormData}
          isDisabled={false}
          handleFiles={handleFiles}
          errors={errors} 
        />

      ))}
    </Box>
  );
};

export default QuestionnaireFormSection;
